import { render, staticRenderFns } from "./DoubleSideRectangularTrapezoidVertical.vue?vue&type=template&id=4558c9f2&scoped=true&"
import script from "./DoubleSideRectangularTrapezoidVertical.vue?vue&type=script&lang=js&"
export * from "./DoubleSideRectangularTrapezoidVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4558c9f2",
  null
  
)

export default component.exports